"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarColors = exports.SnackbarColorPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var SnackbarColors = exports.SnackbarColors = Object.freeze({
  ATTENTION: 'attention',
  ERROR: 'error',
  SUCCESS: 'success'
});
var SnackbarColorPropType = exports.SnackbarColorPropType = _propTypes["default"].oneOf(Object.values(SnackbarColors));